import React, { useState } from 'react';
import AboutNav from '../Components/Navigation/AboutNav';
import Footer from '../Components/Home/Footer';
import SEBISlider from '../Components/Common/SEBISlider';
import ISOCertificateButton from '../Components/Common/ISOCertificateButton';
import PricingForm from '../Components/PricingForm/PricingForm';
import Paynow from './Paynow/Paynow';
import { FaChartLine, FaUserTie, FaRocket, FaCrown, FaGift, FaCheck, FaPhone, FaTimes } from 'react-icons/fa';
import '../Assets/Styles/Pages/pricing_page.css';

const Pricing_page = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [selectedPlanData, setSelectedPlanData] = useState(null);
  const [userPhone, setUserPhone] = useState('');
  const [phoneError, setPhoneError] = useState('');

  const handleGetStarted = (planTitle) => {
    setSelectedPlan(planTitle);
    setIsFormOpen(true);
  };

  const handlePayNow = (planData) => {
    setSelectedPlanData(planData);
    setIsPhoneModalOpen(true);
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
    setSelectedPlan('');
  };

  const handleClosePayment = () => {
    setIsPaymentOpen(false);
    setSelectedPlanData(null);
    setUserPhone('');
    setPhoneError('');
  };

  const handleClosePhoneModal = () => {
    setIsPhoneModalOpen(false);
    setUserPhone('');
    setPhoneError('');
  };

  const validatePhoneNumber = (phone) => {
    const phoneRegex = /^[6-9]\d{9}$/;
    return phoneRegex.test(phone);
  };

  const handlePhoneSubmit = () => {
    setPhoneError('');
    
    if (!userPhone.trim()) {
      setPhoneError('Phone number is required');
      return;
    }
    
    if (!validatePhoneNumber(userPhone)) {
      setPhoneError('Please enter a valid 10-digit Indian phone number');
      return;
    }
    
    // Close phone modal and open payment modal
    setIsPhoneModalOpen(false);
    setIsPaymentOpen(true);
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    if (value.length <= 10) {
      setUserPhone(value);
      setPhoneError('');
    }
  };

  const pricingData = [
    {
      logo: <FaGift className="pricing-icon" />,
      title: "Free Plan",
      description: "Start your investment journey with our free starter package",
      price: "Free",
      features: [
        "Basic Market Overview",
        "Weekly Market Updates",
        "Community Forum Access",
        "Basic Stock Information",
        "Educational Resources"
      ]
    },
    {
      logo: <FaChartLine className="pricing-icon" />,
      title: "Basic Plan",
      description: "Perfect for beginners starting their investment journey",
      price: "₹15000",
      features: [
        "Basic Stock Research",
        "Daily Market Updates",
        "Email Support",
        "Basic Portfolio Tracking",
        "Weekly Newsletter"
      ]
    },
    {
      logo: <FaUserTie className="pricing-icon" />,
      title: "Premium Plan",
      description: "Ideal for active traders and serious investors",
      price: "₹51000",
      features: [
        "Advanced Stock Research",
        "Real-time Market Alerts",
        "Priority Email & Phone Support",
        "Advanced Portfolio Analytics",
        "Daily Research Reports",
        "Trading Strategies"
      ]
    },
    {
      logo: <FaRocket className="pricing-icon" />,
      title: "HNI Plan",
      description: "For professional traders and institutional clients",
      price: "₹121000",
      features: [
        "Premium Stock Research",
        "Instant Market Alerts",
        "24/7 Priority Support",
        "Custom Portfolio Solutions",
        "Exclusive Research Reports",
        "Advanced Trading Strategies",
        "Personal Investment Advisor"
      ]
    },
    {
      logo: <FaCrown className="pricing-icon" />,
      title: "Customized Plan",
      description: "For clients who need a tailored investment solution",
      price: "Custom",
      features: [
        "Custom Research Solutions",
        "Dedicated Support Team",
        "Custom Integration",
        "White-label Solutions",
        "Institutional Reports",
        "Dedicated Account Manager"
      ]
    }
  ];

  return (
    <div className="pricing-page">
      <AboutNav />
      <SEBISlider />
      
      <section className="pricing-hero">
        <div className="pricing-hero-content">
          <h1>Choose Your Investment Plan</h1>
          <p>Select the perfect plan that matches your investment goals and trading style</p>
        </div>
      </section>

      <section className="pricing-container">
        <div className="pricing-grid">
          {pricingData.map((plan, index) => (
            <div key={index} className="pricing-card">
              <div className="pricing-card-header">
                {plan.logo}
                <h2>{plan.title}</h2>
                <p className="pricing-description">{plan.description}</p>
                <div className="pricing-price">{plan.price}</div>
              </div>
              <ul className="pricing-features">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>
                    <FaCheck />
                    {feature}
                  </li>
                ))}
              </ul>
              <button 
                className="pricing-cta" 
                onClick={() => plan.title === "Free Plan" ? handleGetStarted(plan.title) : handlePayNow(plan)}
              >
                {plan.title === "Free Plan" ? "Get Started" : "Pay Now"}
              </button>
            </div>
          ))}
        </div>
      </section>

      <section className="pricing-faq">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-grid">
          <div className="faq-item">
            <h3>Can I upgrade my plan later?</h3>
            <p>Yes, you can upgrade your plan at any time. The price difference will be prorated for the remaining period.</p>
          </div>
          <div className="faq-item">
            <h3>What payment methods do you accept?</h3>
            <p>We accept all major credit cards, UPI, and bank transfers for Indian customers.</p>
          </div>
          <div className="faq-item">
            <h3>Is there a refund policy?</h3>
            <p>Yes, we offer a 7-day money-back guarantee if you're not satisfied with our services.</p>
          </div>
          <div className="faq-item">
            <h3>Do you offer custom solutions?</h3>
            <p>Yes, we provide custom solutions for enterprise clients. Contact us for more details.</p>
          </div>
        </div>
      </section>

      <PricingForm 
        isOpen={isFormOpen}
        onClose={handleCloseForm}
        selectedPlan={selectedPlan}
        pricingData={pricingData}
      />

      {/* Phone Number Modal */}
      {isPhoneModalOpen && selectedPlanData && (
        <div className="phone-modal-overlay">
          <div className="phone-modal">
            <div className="phone-modal-header">
              <h2>Enter Your Phone Number</h2>
              <button className="close-phone-modal-btn" onClick={handleClosePhoneModal}>
                <FaTimes />
              </button>
            </div>
            
            <div className="phone-modal-content">
              <div className="phone-modal-info">
                <div className="phone-icon">
                  <FaPhone />
                </div>
                <h3>Complete Your {selectedPlanData.title} Purchase</h3>
                <p>Please provide your phone number to proceed with the payment</p>
                <div className="plan-summary">
                  <span className="plan-name">{selectedPlanData.title}</span>
                  <span className="plan-price">{selectedPlanData.price}</span>
                </div>
              </div>
              
              <div className="phone-input-section">
                <label htmlFor="phone-input">
                  <FaPhone className="input-icon" />
                  Phone Number
                </label>
                <input
                  type="tel"
                  id="phone-input"
                  value={userPhone}
                  onChange={handlePhoneChange}
                  placeholder="Enter your 10-digit phone number"
                  maxLength="10"
                  className={phoneError ? 'error' : ''}
                />
                {phoneError && (
                  <div className="phone-error">
                    <FaTimes className="error-icon" />
                    {phoneError}
                  </div>
                )}
                <small className="phone-note">
                  We'll use this number for payment verification and service updates
                </small>
              </div>
              
              <div className="phone-modal-actions">
                <button className="cancel-btn" onClick={handleClosePhoneModal}>
                  Cancel
                </button>
                <button 
                  className="proceed-btn" 
                  onClick={handlePhoneSubmit}
                  disabled={!userPhone || phoneError}
                >
                  Proceed to Payment
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Payment Modal */}
      {isPaymentOpen && selectedPlanData && (
        <div className="payment-modal-overlay">
          <div className="payment-modal">
            <Paynow 
              planName={selectedPlanData.title}
              planPrice={selectedPlanData.price}
              userPhone={userPhone}
              onClose={handleClosePayment}
            />
          </div>
        </div>
      )}

      <Footer />
      <ISOCertificateButton />
    </div>
  );
};

export default Pricing_page;
